import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import Strings from '../strings/Strings';
import BaseService from '../services/BaseService';
import Loader from './Loader';
import CustomInput from './CustomInput';
import Geocode from "react-geocode";

class UserDriverCreate extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      user: '',
      user_error: false,
      name: '', nameInvalid: false,
      email: '', emailInvalid: false,
      document: '', documentInvalid: false,
      phone_number: '', phoneNumberInvalid: false,
      mask_phone: '(00) 0000-00000',
      loading: false,
      error_message: '',
      color_message: '',

    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.valid_field = this.valid_field.bind(this);
    this.register = this.register.bind(this);
    Geocode.setApiKey(BaseService.KeyGoogleMap);
  }
  // dispatching an action based on state change
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.editing !== null && nextProps.editing !== this.props.editing) {

      // Convert Document
      var Document = nextProps.editing.document.replace('/','').replace('.','').replace('.','').replace('-','');

      this.setState({
        name: nextProps.editing.name,
        email: nextProps.editing.email,
        document: Document,
        phone_number: nextProps.editing.phone_number,
      });
    }
  }
  toggle(refresh){
    this.setState({
      user: '',
      user_error: false,
      name: '', nameInvalid: false,
      email: '', emailInvalid: false,
      document: '', documentInvalid: false,
      phone_number: '', phoneNumberInvalid: false,
      mask_phone: '(00) 0000-00000',
      loading: false,
      error_message: '',
      color_message: '',
    });
    this.props.toggle(refresh);
  }
  handleInputChange (event) {
    // get target
    const target = event.target;
    // if checkbox or input field
    const value = target.type === 'checkbox' ? target.checked: target.value;
    // get tag name
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  valid_field(){
    var invalid = false;
    if (this.state.name.length<3 || this.state.name.length>40) {
      invalid = true;
      this.setState({nameInvalid: true});
    } else {
      this.setState({nameInvalid: false});
    }
    if (this.state.email.length<10 || this.state.email.length>70) {
      invalid = true;
      this.setState({emailInvalid: true});
    } else {
      this.setState({emailInvalid: false});
    }

    if (this.state.document.length<13 || this.state.document.length>14) {
      invalid = true;
      this.setState({documentInvalid: true});
    } else {
      this.setState({documentInvalid: false});
    }

    if (this.state.phone_number.length<15 || this.state.phone_number.length>16) {
      invalid = true;
      this.setState({phoneNumberInvalid: true});
    } else {
      this.setState({phoneNumberInvalid: false});
    }
    if (this.state.user===null) {
      invalid = true;
      this.setState({user_error: true});
    }

    // Valid inputs
    if(invalid===true){
      return false;
    }

    // Success
    return true;
  }
  register() {
    if (!this.valid_field()) {
      return;
    }
    this.setState({loading: true});
    let url = BaseService.ENDPOINT + this.props.api;
    var msg_success = 'cadastrado';
    if(this.props.editing !== null){
      url += "/"+this.props.editing.id;
      msg_success = 'alterado';
    }
    var form = new FormData();
    form.append("name", this.state.name);
    form.append("email", this.state.email);
    form.append("document", this.state.document);
    form.append("phone_number", this.state.phone_number);
          
		return fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.props.user.access_token,
      }),
      body: form
    })
		.then((response) => response.json())
		.then((json) => {
			if(json.return.code === 1){
        this.setState({
          loading: true,
          error_message: 'Usuário '+msg_success+' com sucesso!',
          color_message: 'success'
        });
      } else if(json.return.code>=300){
        window.location = '/';
      } else {
        this.setState({
          loading: true,
          error_message: json.return.message
        });
      }
		});
  }
  render() {
    let FormGroupDocument = '';
    FormGroupDocument = 
      <CustomInput
        label={(this.props.editing!==null?'CPF':'')}
        invalid={this.state.documentInvalid}
        mask={"000.000.000-00"}
        name="document"
        placeholder='CPF'
        value={this.state.document}
        onChange={(value) => {this.setState({document: value})}}
        unmask={false}
        invalid_message={Strings.required_field}
      />

    return (
      <Modal isOpen={this.props.visible} >
        <ModalHeader>{(this.props.editing!==null?'Editar':'Criar')} Usuário {this.props.title}</ModalHeader>
          <ModalBody hidden={this.state.loading}>
            <Form>
              <FormGroup>
                {(this.props.editing!==null?<Label>{(this.props.api==='admin/user-access-point'?'Nome Fantasia':'Nome')}</Label>:'')}
                <Input
                  type="text"
                  maxLength={50}
                  name="name"
                  placeholder={(this.props.api==='admin/user-access-point'?'Nome Fantasia':'Nome')}
                  value={this.state.name}
                  onChange={this.handleInputChange}
                  invalid={this.state.nameInvalid} >
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <FormGroup>
                {(this.props.editing!==null?<Label>E-mail</Label>:'')}
                <Input
                  type="text"
                  maxLength={70}
                  name="email"
                  placeholder="E-mail"
                  value={this.state.email}
                  onChange={this.handleInputChange}
                  invalid={this.state.emailInvalid}
                ></Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              {FormGroupDocument}
              <CustomInput
                label={(this.props.editing!==null?'Telefone':'')}
                invalid={this.state.phoneNumberInvalid}
                mask={this.state.mask_phone}
                name="phone_number"
                placeholder='Telefone'
                value={this.state.phone_number}
                onChange={(value) => {
                  this.setState({
                    phone_number: value,
                    mask_phone: (value.length>14?'(00) 00000-0000':'(00) 0000-00000')
                  });
                }}
                unmask={false}
                invalid_message={Strings.required_field}
              />
            </Form>
          </ModalBody>
          <Loader
            body={ModalBody}
            hidden={!this.state.loading}
            message={this.state.error_message}
            color_message={this.state.color_message}
            onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
            onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
          />
          <ModalFooter hidden={this.state.loading} >
            <Button outline color="secondary" onClick={this.register}>Salvar</Button>
            <Button outline color="danger" onClick={ () => this.toggle(false)}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    )
  }
}
export default UserDriverCreate;


// WEBPACK FOOTER //
// ./src/components/UserDriverCreate.js